import api from "./api";

/**
 * Blog form ki values ko FormData me badalta hai (image upload ke liye zaroori).
 * values: { title, category, shortDescription, authorName, fullDescription,
 *           date, readTime, tags, metaTitle, metaDescription, focusKeyword,
 *           ogTitle, ogDescription, twitterTitle, twitterDescription, jsonSchema }
 * files:  { image, ogImage, twitterImage }  (File objects, optional)
 * flags:  { removeOgImage, removeTwitterImage }  (sirf update me)
 */
export function buildBlogFormData(values = {}, files = {}, flags = {}) {
  const fd = new FormData();

  Object.entries(values).forEach(([key, val]) => {
    if (val === undefined || val === null) return;
    if (key === "tags" && Array.isArray(val)) fd.append("tags", val.join(","));
    else if (key === "jsonSchema" && typeof val === "object") fd.append("jsonSchema", JSON.stringify(val));
    else fd.append(key, val);
  });

  ["image", "ogImage", "twitterImage"].forEach((k) => {
    if (files[k]) fd.append(k, files[k]);
  });

  if (flags.removeOgImage) fd.append("removeOgImage", "true");
  if (flags.removeTwitterImage) fd.append("removeTwitterImage", "true");

  return fd;
}

export const blogService = {
  // ---------- Public ----------
  // Sab blogs, full data: { blogs, pagination }
  getAll: (params = {}) =>
    api.get("/blogs", { params }).then((res) => res.data),

  // Card data: image, title, shortDescription, authorName, category, slug
  getCards: (params = {}) =>
    api.get("/blogs/cards", { params }).then((res) => res.data),

    // Related blogs (slug se)
  getRelated: (slug, params = {}) =>
    api.get(`/blogs/${slug}/related`, { params }).then((res) => res.data),

  // Ek blog (slug se)
  getBySlug: (slug) =>
    api.get(`/blogs/${slug}`).then((res) => res.data),

  // ---------- Admin (token chahiye) ----------
  create: (formData) =>
    api.post("/blogs", formData).then((res) => res.data),

  update: (id, formData) =>
    api.put(`/blogs/${id}`, formData).then((res) => res.data),

  delete: (id) =>
    api.delete(`/blogs/${id}`).then((res) => res.data),
};

export const categoryService = {
  // Public
  getAll: () =>
    api.get("/categories").then((res) => res.data),

  // Admin
  create: (name) =>
    api.post("/categories", { name }).then((res) => res.data),

  update: (id, name) =>
    api.put(`/categories/${id}`, { name }).then((res) => res.data),

  delete: (id) =>
    api.delete(`/categories/${id}`).then((res) => res.data),
};

export default blogService;